export default "__VITE_ASSET__a30ff886__"